import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, useAuth } from '../App';

export default function FeedbackWidget() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  // Listen for global open requests (e.g. from the "Share feedback" CTA in other modals)
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('lbn:open-feedback', handler);
    return () => window.removeEventListener('lbn:open-feedback', handler);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/feedback`, {
        message: message.trim(),
        name: user?.name || name || null,
        email: user?.email || email || null,
      });
      setDone(true);
      setMessage('');
      setTimeout(() => { setDone(false); setOpen(false); }, 2800);
    } catch { /* silent */ }
    finally { setLoading(false); }
  };

  return (
    <>
      <button
        className="feedback-fab"
        onClick={() => setOpen(true)}
        data-testid="feedback-fab"
        aria-label="Share your thoughts"
      >
        <span style={{ fontSize: 15, marginRight: 6 }}>✦</span>
        Your thoughts
      </button>

      {open && (
        <div className="feedback-overlay" onClick={() => setOpen(false)} data-testid="feedback-overlay">
          <div className="feedback-panel" onClick={e => e.stopPropagation()} data-testid="feedback-panel">
            <button className="feedback-close" onClick={() => setOpen(false)} aria-label="Close">×</button>

            {!done ? (
              <>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 300, color: 'var(--deep)', marginBottom: 6 }}>
                  Share your thoughts
                </div>
                <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 20 }}>
                  What would make Little Blue Numbers better for you and your family? Every thought helps shape what we build next.
                </p>

                <form onSubmit={handleSubmit}>
                  <label className="field-label">Your thoughts</label>
                  <textarea
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    placeholder="What's on your mind?"
                    rows={5}
                    required
                    data-testid="feedback-message"
                    style={{
                      width: '100%', boxSizing: 'border-box', background: 'white',
                      border: '1.5px solid var(--border-strong)', borderRadius: 12,
                      padding: '12px 14px', fontSize: 15, fontFamily: 'inherit',
                      resize: 'vertical', minHeight: 110, marginBottom: 12,
                      color: 'var(--deep)', lineHeight: 1.6,
                    }}
                  />

                  {!user && (
                    <>
                      <label className="field-label">Your name (optional)</label>
                      <input
                        className="field-input"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="First name"
                        data-testid="feedback-name"
                      />
                      <label className="field-label">Email (optional)</label>
                      <input
                        className="field-input"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="So we can reply"
                        data-testid="feedback-email"
                      />
                    </>
                  )}

                  <button
                    type="submit"
                    className="auth-submit"
                    disabled={loading || !message.trim()}
                    data-testid="feedback-submit"
                    style={{ marginTop: 12 }}
                  >
                    {loading ? 'Sending...' : 'Send feedback'}
                  </button>
                </form>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '20px 0' }} data-testid="feedback-done">
                <div style={{ fontSize: 32, marginBottom: 14 }}>✦</div>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, fontWeight: 300, marginBottom: 10 }}>Thank you</div>
                <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7 }}>
                  Your thoughts are in. We read every single one.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
